// import React, { useEffect, useState } from "react"

// import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"

// import { connect } from "react-redux";

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems } from "../../store/actions";

// import axios from "axios";
// import { toast } from "react-toastify";
// import { createMultipleStudnet } from "helpers/student_helper";
// import Loader from "components/Loader/Loader";
// import { STUDENT_DEMO_FILE } from "helpers/url_helper";
// import { useNavigate } from "react-router-dom";
// import { fetchAllBatch } from "helpers/batch_helper";
// import Select from "react-select"


// const CreateMultipleStudent = (props) => {
//     document.title = "Student Management | Create Multiple Student";
//     const [spanDisplay, setSpanDisplay] = useState("none");

//     const [loader, setLoader] = useState(false);
//     const [file, setFile] = useState(null);
//     const navigate = useNavigate();
//     const [allBatch, setAllBatch] = useState([]);
//     const [batch, setBatch] = useState(null);
//     const [orgId, setOrgId] = useState(JSON.parse(localStorage.getItem("authUser"))?.organizationId);


//     const breadcrumbItems = [
//         { title: "Students", link: "#" },
//         { title: "Create Multiple Student", link: "#" },
//     ]
//     useEffect(() => {           /* For closing the sidebar if opened */
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])



//     useEffect(() => {
//         props.setBreadcrumbItems('Create Student', breadcrumbItems)
//     })


//     const getAllBatches = async () => {
//         try {
//             setLoader(true);
//             const result = await fetchAllBatch();
//             if (result?.success) {
//                 setAllBatch(result?.result);
//             }
//             else {
//                 toast.error(result?.message);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.message);
//         } finally {
//             setLoader(false);
//         }

//     }


//     useEffect(() => {
//         getAllBatches();
//     }, []);

//     const handleDownloadClick = async () => {
//         try {
//             setLoader(true);
//             const organizationId = JSON.parse(localStorage.getItem("authUser"))?.organizationId;
//             console.log("organizationId", organizationId)
//             const response = await axios.get(STUDENT_DEMO_FILE, {
//                 responseType: 'blob', // Set response type to 'blob' to receive binary data
//                 headers: {
//                     "X-Organization-ID": organizationId // 👈 add your orgId here
//                 }
//             });

//             const blob = new Blob([response.data], { type: response.headers['content-type'] });

//             // Create a URL for the blob data
//             const url = window.URL.createObjectURL(blob);

//             // Create a link element
//             const link = document.createElement('a');
//             link.href = url;

//             // Specify the filename for the downloaded file
//             link.setAttribute('download', 'students_file_format.xlsx');

//             // Append the link to the body
//             document.body.appendChild(link);

//             // Click the link to trigger the download
//             link.click();

//             // Clean up: remove the link and revoke the URL object
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.log(error);
//             toast.error(error?.response?.data?.message || "Something went wrong");

//         } finally {
//             setLoader(false);
//         }
//     }

//     const handleFileUpload = async (e) => {
//         console.log(e.target.files[0]);
//         setFile(e.target.files[0]);

//     };

//     const handleSubmit = async (e) => {


//         e.preventDefault();
//         if (!file) {
//             setSpanDisplay("inline")

//         }
//         else {
//             try {
//                 setLoader(true);
//                 const formData = new FormData();
//                 formData.append('file', file);
//                 formData.append('batchDto', JSON.stringify(batch));
//                 const result = await createMultipleStudnet(formData);

//                 if (result?.success) {
//                     toast.success("Students Created Successfully");
//                     setFile(null);
//                 }
//                 else {
//                     toast.error(result?.message || "Something went wrong");
//                 }
//             } catch (error) {
//                 console.log(error);
//                 toast.error(error?.response?.data?.message || "Something went wrong");
//             } finally {
//                 setLoader(false);
//             }

//         }
//     };

//     const handleBatchChange = (selectedValue) => {
//         setBatch(selectedValue);

//     }

//     return (
//         <React.Fragment>
//             {loader ? (
//                 <Loader />
//             ) : ("")}
//             <Row>

//                 <Col>
//                     <Card>
//                         <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
//                             {/* <CardBody className="" style={{ minHeight: "70vh", }}> */}

//                             <div className="d-flex justify-content-between mb-3">

//                                 <CardTitle className="h4">Create Student</CardTitle>

//                                 <div className="">
//                                     <button type="submit" className="btn btn-info w-md" onClick={handleDownloadClick}>Download Demo File</button>
//                                 </div>
//                             </div>

//                             <form onSubmit={handleSubmit}>

//                                 <Row className="mb-3">
//                                     <label
//                                         htmlFor="example-text-input"
//                                         className="col-md-2 col-form-label"
//                                     >
//                                         Upload File
//                                     </label>
//                                     <div className="col-md-10">
//                                         <input
//                                             type="file"
//                                             accept='.xlsx'
//                                             name='xlsxFile'
//                                             id='xlsxFile'
//                                             placeholder='Upload a File'
//                                             className='form-control form-control-file'
//                                             data-buttonname="btn-secondary"
//                                             onChange={handleFileUpload} />
//                                         {!file && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

//                                     </div>
//                                 </Row>
//                                 <Row className="mb-3">
//                                     <label
//                                         htmlFor="example-text-input"
//                                         className="col-md-2 col-form-label"
//                                     >
//                                         Batch
//                                     </label>
//                                     <div className="col-md-10">
//                                         {orgId == 2 ?
//                                             <Select

//                                                 value={batch}
//                                                 onChange={handleBatchChange}
//                                                 options={allBatch}
//                                                 getOptionLabel={option => option.batchName + " (" + option.trainingStartDate + " - " + option.trainingEndDate + ")"}
//                                                 getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
//                                                 classNamePrefix="select2-selection"
//                                             />
//                                             :
//                                             <Select

//                                                 value={batch}
//                                                 onChange={handleBatchChange}
//                                                 options={allBatch}
//                                                 getOptionLabel={option => option.batchName}
//                                                 getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
//                                                 classNamePrefix="select2-selection"
//                                             />
//                                         }


//                                     </div>
//                                 </Row>


//                                 <Row className="mb-3">
//                                     <div className="mt-4">
//                                         <button type="submit" className="btn btn-primary w-md">Submit</button>
//                                     </div>
//                                 </Row>
//                             </form>

//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>



//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(CreateMultipleStudent);










import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axios from "axios";
import { toast } from "react-toastify";
import { createMultipleStudnet } from "helpers/student_helper";
import Loader from "components/Loader/Loader";
import { STUDENT_DEMO_FILE } from "helpers/url_helper";
import { useNavigate } from "react-router-dom";
import { fetchAllBatch } from "helpers/batch_helper";
import Select from "react-select";
import { Paper, TextField, Modal as MuiModal, Fade, Backdrop, CircularProgress, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "reactstrap";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

const CreateMultipleStudent = (props) => {
    document.title = "Student Management | Create Multiple Student";
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [file, setFile] = useState(null);
    const navigate = useNavigate();
    const [allBatch, setAllBatch] = useState([]);
    const [batch, setBatch] = useState(null);
    const [orgId, setOrgId] = useState(JSON.parse(localStorage.getItem("authUser"))?.organizationId);
    
    // Modal states
    const [batchModalOpen, setBatchModalOpen] = useState(false);
    const [modalLoader, setModalLoader] = useState(false);
    const [modalSearchText, setModalSearchText] = useState("");
    const [modalFilterState, setModalFilterState] = useState("");
    const [modalFilterDepot, setModalFilterDepot] = useState("");
    const [modalFilteredBatches, setModalFilteredBatches] = useState([]);
    const [availableStates, setAvailableStates] = useState([]);
    const [availableDepots, setAvailableDepots] = useState([]);
    const [modalError, setModalError] = useState(null);

    const breadcrumbItems = [
        { title: "Students", link: "#" },
        { title: "Create Multiple Student", link: "#" },
    ];

    // Close sidebar on mobile
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click();
        }
    }, []);

    useEffect(() => {
        props.setBreadcrumbItems('Create Student', breadcrumbItems);
    }, []);

    // ============================
    // FETCH BATCHES
    // ============================
    const getAllBatches = async () => {
        try {
            setLoader(true);
            const result = await fetchAllBatch();
            if (result?.success) {
                const batches = (result.result || []).map(batch => ({
                    id: batch.id || batch._id,
                    batchName: batch.batchName,
                    department: batch.department,
                    state: batch.state,
                    depot: batch.depot,
                    trainingStartDate: batch.trainingStartDate,
                    trainingEndDate: batch.trainingEndDate,
                    totalStudents: batch.totalStudents || batch.students?.length || 0,
                    passedStudents: batch.passedStudents || 0,
                    failedStudents: batch.failedStudents || 0,
                    notAttemptedStudents: batch.notAttemptedStudents || 0,
                    passPercentage: batch.passPercentage || 0,
                    trainerNames: batch.trainerNames || batch.trainers?.map(t => t.name || t.firstName).join(", ") || "No Trainer Assigned",
                    totalTrainers: batch.totalTrainers || batch.trainers?.length || 0,
                    batchType: batch.batchType || "Regular",
                    status: batch.status || "Active"
                }));
                setAllBatch(batches);
                setModalFilteredBatches(batches);

                // Extract unique states and depots for filters
                const uniqueStates = new Set();
                const uniqueDepots = new Set();
                batches.forEach(batch => {
                    if (batch.state) uniqueStates.add(batch.state);
                    if (batch.depot) uniqueDepots.add(batch.depot);
                });
                setAvailableStates([...uniqueStates]);
                setAvailableDepots([...uniqueDepots]);
            } else {
                toast.error(result?.message || "Failed to load batches");
            }
        } catch (error) {
            console.error("Error fetching batches:", error);
            toast.error(error?.response?.data?.message || "Failed to load batches");
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getAllBatches();
    }, []);

    // ============================
    // FETCH BATCHES FOR MODAL
    // ============================
    const fetchBatchesForModal = async () => {
        try {
            setModalLoader(true);
            setModalError(null);
            
            const result = await fetchAllBatch();
            if (result?.success) {
                const batches = (result.result || []).map(batch => ({
                    id: batch.id || batch._id,
                    batchName: batch.batchName,
                    department: batch.department,
                    state: batch.state,
                    depot: batch.depot,
                    trainingStartDate: batch.trainingStartDate,
                    trainingEndDate: batch.trainingEndDate,
                    totalStudents: batch.totalStudents || batch.students?.length || 0,
                    passedStudents: batch.passedStudents || 0,
                    failedStudents: batch.failedStudents || 0,
                    notAttemptedStudents: batch.notAttemptedStudents || 0,
                    passPercentage: batch.passPercentage || 0,
                    trainerNames: batch.trainerNames || batch.trainers?.map(t => t.name || t.firstName).join(", ") || "No Trainer Assigned",
                    totalTrainers: batch.totalTrainers || batch.trainers?.length || 0,
                    batchType: batch.batchType || "Regular",
                    status: batch.status || "Active"
                }));
                setAllBatch(batches);
                setModalFilteredBatches(batches);

                // Extract unique states and depots for filters
                const uniqueStates = new Set();
                const uniqueDepots = new Set();
                batches.forEach(batch => {
                    if (batch.state) uniqueStates.add(batch.state);
                    if (batch.depot) uniqueDepots.add(batch.depot);
                });
                setAvailableStates([...uniqueStates]);
                setAvailableDepots([...uniqueDepots]);
            } else {
                setModalError(result?.message || "Failed to load batches");
                toast.error(result?.message || "Failed to load batches");
            }
        } catch (error) {
            console.error("Error fetching batches for modal:", error);
            const errorMsg = error?.response?.data?.message || error?.message || "Failed to load batches";
            setModalError(errorMsg);
            toast.error(errorMsg);
        } finally {
            setModalLoader(false);
        }
    };

    // ============================
    // APPLY MODAL FILTERS
    // ============================
    const applyModalFilters = useCallback(() => {
        let filtered = [...allBatch];

        if (modalFilterState && modalFilterState !== "") {
            filtered = filtered.filter(batch => batch.state === modalFilterState);
        }

        if (modalFilterDepot && modalFilterDepot !== "") {
            filtered = filtered.filter(batch => batch.depot === modalFilterDepot);
        }

        if (modalSearchText) {
            const search = modalSearchText.toLowerCase().trim();
            filtered = filtered.filter(batch => {
                return (
                    (batch.batchName || "").toLowerCase().includes(search) ||
                    (batch.department || "").toLowerCase().includes(search) ||
                    (batch.depot || "").toLowerCase().includes(search) ||
                    (batch.state || "").toLowerCase().includes(search) ||
                    (batch.trainerNames || "").toLowerCase().includes(search) ||
                    formatDateToDDMMYYYY(batch.trainingStartDate).includes(search) ||
                    formatDateToDDMMYYYY(batch.trainingEndDate).includes(search)
                );
            });
        }

        setModalFilteredBatches(filtered);
    }, [allBatch, modalFilterState, modalFilterDepot, modalSearchText]);

    useEffect(() => {
        if (batchModalOpen && allBatch.length > 0) {
            applyModalFilters();
        }
    }, [batchModalOpen, modalFilterState, modalFilterDepot, modalSearchText, allBatch, applyModalFilters]);

    // ============================
    // HELPER FUNCTIONS
    // ============================
    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        if (moment(dateStr, moment.ISO_8601, true).isValid()) {
            return moment(dateStr);
        }
        if (moment(dateStr, "DD/MM/YYYY", true).isValid()) {
            return moment(dateStr, "DD/MM/YYYY");
        }
        if (moment(dateStr, "DD-MM-YYYY", true).isValid()) {
            return moment(dateStr, "DD-MM-YYYY");
        }
        if (moment(dateStr, "YYYY-MM-DD", true).isValid()) {
            return moment(dateStr, "YYYY-MM-DD");
        }
        const parsed = moment(dateStr);
        return parsed.isValid() ? parsed : null;
    };

    const formatDateToDDMMYYYY = useCallback((dateStr) => {
        if (!dateStr) return "N/A";
        const date = parseDate(dateStr);
        if (date && date.isValid()) {
            return date.format("DD/MM/YYYY");
        }
        try {
            if (typeof dateStr === "string") {
                if (dateStr.includes("-")) {
                    const datePart = dateStr.split("T")[0];
                    const [year, month, day] = datePart.split("-");
                    return `${day}/${month}/${year}`;
                }
                if (dateStr.includes("/")) {
                    return dateStr;
                }
            }
            if (dateStr instanceof Date) {
                const day = dateStr.getDate().toString().padStart(2, "0");
                const month = (dateStr.getMonth() + 1).toString().padStart(2, "0");
                const year = dateStr.getFullYear();
                return `${day}/${month}/${year}`;
            }
            return String(dateStr);
        } catch (error) {
            return String(dateStr);
        }
    }, []);

    // ============================
    // HANDLE DOWNLOAD DEMO FILE
    // ============================
    const handleDownloadClick = async () => {
        try {
            setLoader(true);
            const organizationId = JSON.parse(localStorage.getItem("authUser"))?.organizationId;
            const response = await axios.get(STUDENT_DEMO_FILE, {
                responseType: 'blob',
                headers: {
                    "X-Organization-ID": organizationId
                }
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'students_file_format.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download error:", error);
            toast.error(error?.response?.data?.message || "Failed to download demo file");
        } finally {
            setLoader(false);
        }
    };

    // ============================
    // HANDLE FILE UPLOAD
    // ============================
    const handleFileUpload = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        if (selectedFile) {
            setSpanDisplay("none");
        }
    };

    // ============================
    // HANDLE SUBMIT - KEEP ORIGINAL BEHAVIOR
    // ============================
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate file only - batch is optional
        if (!file) {
            setSpanDisplay("inline");
            toast.error("Please upload a file");
            return;
        }
        
        try {
            setLoader(true);
            const formData = new FormData();
            formData.append('file', file);
            // Send batch as null if not selected - this works with the backend
            formData.append('batchDto', JSON.stringify(batch));
            
            const result = await createMultipleStudnet(formData);

            if (result?.success) {
                toast.success(result?.message || "Students Created Successfully");
                setFile(null);
                setBatch(null);
                // Reset file input
                const fileInput = document.getElementById('xlsxFile');
                if (fileInput) fileInput.value = '';
                getAllBatches();
            } else {
                toast.error(result?.message || "Failed to create students");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    // ============================
    // HANDLE BATCH SELECTION
    // ============================
    const handleBatchChange = (selectedValue) => {
        setBatch(selectedValue);
    };

    // ============================
    // HANDLE BATCH SELECTION FROM MODAL
    // ============================
    const handleBatchSelect = (row) => {
        const selectedBatch = {
            id: row.id,
            batchName: row.batchName,
            trainingStartDate: row.trainingStartDate,
            trainingEndDate: row.trainingEndDate,
            department: row.department,
            state: row.state,
            depot: row.depot
        };
        setBatch(selectedBatch);
        setBatchModalOpen(false);
        toast.success(`Selected batch: ${row.batchName}`);
    };

    // ============================
    // OPEN BATCH SELECTION MODAL
    // ============================
    const openBatchModal = async () => {
        try {
            setBatchModalOpen(true);
            setModalSearchText("");
            setModalFilterState("");
            setModalFilterDepot("");
            setModalFilteredBatches([]);
            setModalError(null);
            
            // Fetch fresh data when modal opens
            await fetchBatchesForModal();
        } catch (error) {
            console.error("Error opening modal:", error);
            toast.error("Failed to load batches");
        }
    };

    // ============================
    // CLEAR MODAL FILTERS
    // ============================
    const clearModalFilters = () => {
        setModalSearchText("");
        setModalFilterState("");
        setModalFilterDepot("");
    };

    // ============================
    // HANDLE VIEW BATCH DETAILS
    // ============================
    const handleViewDetails = (row) => {
        navigate(`/batch/${row.id}`);
    };

    // ============================
    // REFRESH MODAL DATA
    // ============================
    const refreshModalData = async () => {
        await fetchBatchesForModal();
    };

    // ============================
    // MODAL DATA GRID COLUMNS
    // ============================
    const modalColumns = [
        { 
            field: "serialNo", 
            headerName: "S.No", 
            width: 70 
        },
        {
            field: "batchName",
            headerName: "Batch Name",
            width: 200,
            renderCell: (params) => {
                return (
                    <span
                        style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
                        onClick={() => handleViewDetails(params.row)}
                        title={`${params.row.totalStudents || 0} student(s)`}
                    >
                        {params.value}
                    </span>
                );
            },
        },
        { 
            field: "department", 
            headerName: "Department", 
            width: 150 
        },
        {
            field: "trainerNames",
            headerName: "Trainer(s)",
            width: 200,
            renderCell: (params) => {
                return <span>{params.value || "No Trainer Assigned"}</span>;
            },
        },
        {
            field: "state",
            headerName: "State",
            width: 130,
            renderCell: (params) => params.value || "N/A",
        },
        {
            field: "depot",
            headerName: "Depot",
            width: 130,
            renderCell: (params) => params.value || "N/A",
        },
        {
            field: "trainingStartDate",
            headerName: "Start Date",
            width: 130,
            renderCell: (params) => formatDateToDDMMYYYY(params.value),
        },
        {
            field: "trainingEndDate",
            headerName: "End Date",
            width: 130,
            renderCell: (params) => formatDateToDDMMYYYY(params.value),
        },
        {
            field: "totalStudents",
            headerName: "Students",
            width: 90,
            renderCell: (params) => (
                <span style={{ fontWeight: "bold", color: params.value > 0 ? "#198754" : "#6c757d" }}>
                    {params.value || 0}
                </span>
            ),
        },
        {
            field: "passPercentage",
            headerName: "Pass %",
            width: 80,
            renderCell: (params) => (
                <span style={{ fontWeight: "bold", color: (params.value || 0) >= 80 ? "#198754" : "#dc3545" }}>
                    {params.value || 0}%
                </span>
            ),
        },
        {
            field: "batchType",
            headerName: "Type",
            width: 100,
            renderCell: (params) => (
                <span className={`badge bg-${params.value === "Regular" ? "primary" : "info"}`}>
                    {params.value || "Regular"}
                </span>
            ),
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,
            renderCell: (params) => (
                <span className={`badge bg-${params.value === "Active" ? "success" : "secondary"}`}>
                    {params.value || "Active"}
                </span>
            ),
        },
        {
            field: "select",
            headerName: "Action",
            width: 130,
            renderCell: (params) => (
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => handleBatchSelect(params.row)}
                    style={{ padding: "4px 12px" }}
                >
                    <i className="fas fa-check me-1"></i> Select
                </Button>
            ),
        },
    ];

    return (
        <React.Fragment>
            {loader && <Loader />}

            <Row>
                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <div className="d-flex justify-content-between mb-3">
                                <CardTitle className="h4">Create Student</CardTitle>
                                <div className="">
                                    <button type="button" className="btn btn-info w-md" onClick={handleDownloadClick}>
                                        <i className="fas fa-download me-2"></i>Download Demo File
                                    </button>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Upload File <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-md-10">
                                        <input
                                            type="file"
                                            accept='.xlsx'
                                            name='xlsxFile'
                                            id='xlsxFile'
                                            placeholder='Upload a File'
                                            className='form-control form-control-file'
                                            data-buttonname="btn-secondary"
                                            onChange={handleFileUpload}
                                        />
                                        {!file && <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
                                            This field is required
                                        </span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Batch <span className="text-muted">(Optional)</span>
                                    </label>
                                    <div className="col-md-10">
                                        <div className="d-flex gap-2">
                                            <div style={{ flex: 1 }}>
                                                {orgId == 2 ? (
                                                    <Select
                                                        value={batch}
                                                        onChange={handleBatchChange}
                                                        options={allBatch}
                                                        getOptionLabel={option => option.batchName + " (" + option.trainingStartDate + " - " + option.trainingEndDate + ")"}
                                                        getOptionValue={option => option.id.toString()}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select a batch (optional)..."
                                                        isClearable
                                                    />
                                                ) : (
                                                    <Select
                                                        value={batch}
                                                        onChange={handleBatchChange}
                                                        options={allBatch}
                                                        getOptionLabel={option => option.batchName}
                                                        getOptionValue={option => option.id.toString()}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select a batch (optional)..."
                                                        isClearable
                                                    />
                                                )}
                                            </div>
                                            <Button 
                                                color="success" 
                                                size="sm" 
                                                onClick={openBatchModal}
                                                style={{ whiteSpace: "nowrap" }}
                                            >
                                                <i className="fas fa-list me-1"></i> Browse
                                            </Button>
                                        </div>
                                        <small className="text-muted d-block mt-1">
                                            <i className="fas fa-info-circle me-1"></i>
                                            Batch is optional. You can upload students without assigning a batch.
                                        </small>
                                    </div>
                                </Row>

                                {/* Selected Batch Display */}
                                {batch && (
                                    <div className="alert alert-success mb-3" role="alert">
                                        <i className="fas fa-check-circle me-2"></i>
                                        <strong>Selected Batch:</strong> {batch.batchName}
                                        {batch.department && (
                                            <span className="ms-3 text-muted">
                                                <i className="fas fa-building me-1"></i> {batch.department}
                                            </span>
                                        )}
                                        {batch.state && (
                                            <span className="ms-3 text-muted">
                                                <i className="fas fa-map-marker-alt me-1"></i> {batch.state}
                                            </span>
                                        )}
                                        <button
                                            type="button"
                                            className="btn-close float-end"
                                            onClick={() => setBatch(null)}
                                            aria-label="Clear selection"
                                        ></button>
                                    </div>
                                )}

                                <Row className="mb-3">
                                    <div className="mt-4 d-flex gap-2 flex-wrap">
                                        <button type="submit" className="btn btn-primary w-md">
                                            <i className="fas fa-upload me-2"></i>Submit
                                        </button>
                                        {batch && (
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary w-md"
                                                onClick={() => setBatch(null)}
                                            >
                                                <i className="fas fa-times me-2"></i>Clear Batch
                                            </button>
                                        )}
                                    </div>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* ================================ */}
            {/* BATCH SELECTION MODAL */}
            {/* ================================ */}
            <MuiModal
                open={batchModalOpen}
                onClose={() => setBatchModalOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Fade in={batchModalOpen}>
                    <Paper
                        style={{
                            width: '95%',
                            maxWidth: '1400px',
                            maxHeight: '90vh',
                            overflow: 'hidden',
                            padding: '24px',
                            position: 'relative',
                            borderRadius: '12px',
                        }}
                    >
                        {/* Modal Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <h4 className="mb-0">
                                    <i className="fas fa-list me-2 text-primary"></i>
                                    Browse Batches
                                    {modalLoader && (
                                        <CircularProgress size={20} style={{ marginLeft: '12px' }} />
                                    )}
                                </h4>
                                <small className="text-muted">
                                    {!modalLoader && modalFilteredBatches.length > 0 && (
                                        <span>{modalFilteredBatches.length} batches available</span>
                                    )}
                                    {!modalLoader && modalFilteredBatches.length === 0 && allBatch.length === 0 && (
                                        <span>No batches found</span>
                                    )}
                                </small>
                            </div>
                            <div className="d-flex gap-2">
                                <Button
                                    color="light"
                                    size="sm"
                                    onClick={refreshModalData}
                                    disabled={modalLoader}
                                    style={{ borderRadius: '50%', width: '36px', height: '36px' }}
                                    title="Refresh"
                                >
                                    <i className="fas fa-sync"></i>
                                </Button>
                                <Button
                                    color="light"
                                    size="sm"
                                    onClick={() => setBatchModalOpen(false)}
                                    style={{ borderRadius: '50%', width: '36px', height: '36px' }}
                                >
                                    <CloseIcon style={{ fontSize: '20px' }} />
                                </Button>
                            </div>
                        </div>

                        {/* Modal Filters */}
                        <Row className="mb-3">
                            <Col md={4}>
                                <TextField
                                    fullWidth
                                    placeholder="Search batches by name, department, trainer..."
                                    value={modalSearchText}
                                    onChange={(e) => setModalSearchText(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    disabled={modalLoader}
                                    InputProps={{
                                        startAdornment: <SearchIcon style={{ marginRight: 8, color: "#6c757d" }} />,
                                    }}
                                />
                            </Col>
                            <Col md={3}>
                                <Select
                                    options={availableStates.map(s => ({ value: s, label: s }))}
                                    value={modalFilterState ? { value: modalFilterState, label: modalFilterState } : null}
                                    onChange={(option) => setModalFilterState(option?.value || "")}
                                    placeholder="Filter by State"
                                    isClearable
                                    isDisabled={modalLoader}
                                />
                            </Col>
                            <Col md={3}>
                                <Select
                                    options={availableDepots.map(d => ({ value: d, label: d }))}
                                    value={modalFilterDepot ? { value: modalFilterDepot, label: modalFilterDepot } : null}
                                    onChange={(option) => setModalFilterDepot(option?.value || "")}
                                    placeholder="Filter by Depot"
                                    isClearable
                                    isDisabled={modalLoader}
                                />
                            </Col>
                            <Col md={2}>
                                <Button 
                                    color="secondary" 
                                    size="sm" 
                                    onClick={clearModalFilters}
                                    disabled={modalLoader}
                                    style={{ width: "100%" }}
                                >
                                    <i className="fas fa-times me-1"></i> Clear
                                </Button>
                            </Col>
                        </Row>

                        {/* Error Display */}
                        {modalError && (
                            <div className="alert alert-danger mb-3" role="alert">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                {modalError}
                                <button
                                    type="button"
                                    className="btn-close float-end"
                                    onClick={() => setModalError(null)}
                                    aria-label="Close"
                                ></button>
                            </div>
                        )}

                        {/* Loading State */}
                        {modalLoader ? (
                            <Box 
                                display="flex" 
                                flexDirection="column" 
                                alignItems="center" 
                                justifyContent="center"
                                style={{ height: '400px' }}
                            >
                                <CircularProgress size={60} />
                                <p className="mt-3 text-muted">Loading batches...</p>
                            </Box>
                        ) : (
                            /* Modal Table */
                            <div style={{ height: 'calc(90vh - 280px)', overflow: 'auto' }}>
                                {modalFilteredBatches.length === 0 && allBatch.length === 0 ? (
                                    <Box 
                                        display="flex" 
                                        flexDirection="column" 
                                        alignItems="center" 
                                        justifyContent="center"
                                        style={{ height: '200px' }}
                                    >
                                        <i className="fas fa-inbox" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                        <p className="mt-3 text-muted">No batches available</p>
                                    </Box>
                                ) : modalFilteredBatches.length === 0 && allBatch.length > 0 ? (
                                    <Box 
                                        display="flex" 
                                        flexDirection="column" 
                                        alignItems="center" 
                                        justifyContent="center"
                                        style={{ height: '200px' }}
                                    >
                                        <i className="fas fa-search" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                        <p className="mt-3 text-muted">No batches match your filters</p>
                                        <Button color="secondary" size="sm" onClick={clearModalFilters}>
                                            Clear Filters
                                        </Button>
                                    </Box>
                                ) : (
                                    <DataGrid
                                        rows={modalFilteredBatches.map((r, i) => ({
                                            ...r,
                                            serialNo: i + 1,
                                            id: r.id,
                                        }))}
                                        columns={modalColumns}
                                        pageSizeOptions={[10, 25, 50, 100]}
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 10, page: 0 } },
                                        }}
                                        disableRowSelectionOnClick
                                        sx={{
                                            "& .MuiDataGrid-cell:focus": { outline: "none" },
                                            "& .MuiDataGrid-columnHeaders": { 
                                                backgroundColor: "#f8f9fa", 
                                                fontWeight: "bold",
                                                borderBottom: "2px solid #dee2e6"
                                            },
                                            "& .MuiDataGrid-row:hover": {
                                                backgroundColor: "#f5f9ff"
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        )}

                        {/* Modal Footer */}
                        <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                            <div>
                                <small className="text-muted">
                                    <i className="fas fa-info-circle me-1"></i>
                                    Click "Select" to choose a batch or click batch name to view details.
                                    {!modalLoader && modalFilteredBatches.length > 0 && allBatch.length > 0 && (
                                        <span className="ms-2">
                                            Showing {modalFilteredBatches.length} of {allBatch.length} batches
                                        </span>
                                    )}
                                </small>
                            </div>
                            <div className="d-flex gap-2">
                                <Button 
                                    color="secondary" 
                                    onClick={() => setBatchModalOpen(false)}
                                    disabled={modalLoader}
                                >
                                    <i className="fas fa-times me-1"></i> Close
                                </Button>
                            </div>
                        </div>
                    </Paper>
                </Fade>
            </MuiModal>
        </React.Fragment>
    );
};

export default connect(null, { setBreadcrumbItems })(CreateMultipleStudent);